import { Injectable } from '@angular/core';
import { Analytics, setAnalyticsCollectionEnabled } from 'firebase/analytics';

@Injectable({
  providedIn: 'root',
})
export class AngularFireAnalytics {
  constructor(
    private readonly analytics: Analytics,
    private readonly disabled = false,
  ) {}

  setAnalyticsCollectionEnabled(enabled: boolean): void {
    if (this.disabled) return;
    setAnalyticsCollectionEnabled(this.analytics, enabled);
  }
}
